"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _reactFlatpickr = _interopRequireDefault(require("react-flatpickr")),
    _moment = _interopRequireDefault(require("moment")),
    _lodash2 = _interopRequireDefault(require("lodash.isequal")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _components = require("../../../common/components"),
    _datePickerContainer = _interopRequireDefault(require("../styles/datePickerContainer"));

require("flatpickr/dist/themes/airbnb.css"), require("../styles/_date-picker.scss");

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

function ensureDateFormat(a) {
  return a ? (0, _moment["default"])(a).toDate() : null;
}

var DatePicker = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.clearDatePicker = (0, _lodash["default"])(function (a) {
      return function () {
        var b = document.getElementById(a);
        b && b._flatpickr && b._flatpickr.clear();
      };
    }), d.onChange = (0, _lodash["default"])(function (a) {
      return function (b) {
        a(b[0] ? (0, _moment["default"])(b[0]) : null);
      };
    }), d.isEndDateOutsideRange = function (a) {
      var b = d.props,
          c = b.enablePastDays,
          e = b.startDate,
          f = b.endDate;
      if (f && (0, _moment["default"])(f).isSame((0, _moment["default"])(a), "day")) return !1;
      var g = e && (0, _moment["default"])(a).isBefore(e);
      if (g) return !0;
      var h = 0 > (0, _moment["default"])(a).diff((0, _moment["default"])(), "days");
      return !c && h;
    }, d.isStartDateOutsideRange = function (a) {
      var b = d.props,
          c = b.enablePastDays,
          e = b.endDate,
          f = b.startDate;
      if (f && (0, _moment["default"])(f).isSame((0, _moment["default"])(a), "day")) return !1;
      var g = e && (0, _moment["default"])(a).isAfter(e);
      if (g) return !0;
      var h = 0 > (0, _moment["default"])(a).diff((0, _moment["default"])(), "days");
      return !c && h;
    }, d.renderDatePicker = function (a) {
      var b = a.date,
          c = a.onDateChange,
          e = a.onFocus,
          f = a.onBlur,
          g = a.id,
          h = a.placeholder,
          i = a.disabledDates,
          j = a.label,
          k = d.props,
          l = k.enableTime,
          m = k.displayDateFormat,
          n = k.openDown,
          o = k.disabled,
          p = ensureDateFormat(b),
          q = "".concat(g, "-flatpicker");
      return _react["default"].createElement(_components.LabelWrapper, {
        id: g,
        label: j
      }, _react["default"].createElement(_reactFlatpickr["default"], {
        id: q,
        className: "date-picker",
        value: p,
        options: {
          defaultDate: p,
          onChange: c,
          openDirection: n ? "below" : "above",
          formatDate: function formatDate(a) {
            return (0, _moment["default"])(a).format(m);
          },
          disable: i,
          disabled: o,
          enableTime: l,
          wrap: !0
        }
      }, _react["default"].createElement("div", {
        className: "date-picker__block"
      }, _react["default"].createElement("input", {
        className: "date-picker__input",
        type: "text",
        placeholder: h,
        disabled: o,
        onFocus: e,
        onBlur: f,
        "data-input": !0
      }), b ? _react["default"].createElement(_Icon["default"], {
        className: "date-picker__clear",
        onClick: d.clearDatePicker(q),
        name: "close",
        size: 10,
        color: "regent"
      }) : _react["default"].createElement("div", {
        className: "date-picker__toggle",
        "data-toggle": !0
      }, _react["default"].createElement(_Icon["default"], {
        name: "bookings"
      })))));
    }, d.state = {
      startFocused: !1,
      endFocused: !1
    }, d.onFocus = d.onFocus.bind((0, _assertThisInitialized2["default"])(d)), d.onBlur = d.onBlur.bind((0, _assertThisInitialized2["default"])(d)), d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(a, b) {
      return !(0, _lodash2["default"])(this.props, a) || !(0, _lodash2["default"])(this.state, b);
    }
  }, {
    key: "onFocus",
    value: function onFocus(a) {
      var b = this;
      return function () {
        b.setState((0, _defineProperty2["default"])({}, a, !0));
      };
    }
  }, {
    key: "onBlur",
    value: function onBlur(a) {
      var b = this;
      return function () {
        b.setState((0, _defineProperty2["default"])({}, a, !1));
      };
    }
  }, {
    key: "renderEndDatePicker",
    value: function renderEndDatePicker() {
      var a = this.props,
          b = a.onSelectEndDate,
          c = a.endDate,
          d = a.id,
          e = a.endLabel,
          f = a.endPlaceholder;
      return b ? this.renderDatePicker({
        date: c,
        onDateChange: this.onChange(b),
        onFocus: this.onFocus("endFocused"),
        onBlur: this.onBlur("endFocused"),
        id: "".concat(d, "-end"),
        placeholder: f || "Select end date",
        label: e,
        disabledDates: [this.isEndDateOutsideRange]
      }) : null;
    }
  }, {
    key: "renderStartDatePicker",
    value: function renderStartDatePicker() {
      var a = this.props,
          b = a.onSelectStartDate,
          c = a.startDate,
          d = a.id,
          e = a.startLabel,
          f = a.startPlaceholder;
      return this.renderDatePicker({
        date: c,
        onDateChange: this.onChange(b),
        onFocus: this.onFocus("startFocused"),
        onBlur: this.onBlur("startFocused"),
        id: "".concat(d, "-start"),
        placeholder: f || "Select start date",
        label: e,
        disabledDates: [this.isStartDateOutsideRange]
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: _datePickerContainer["default"]
      }, this.renderStartDatePicker(), this.renderEndDatePicker());
    }
  }]), b;
}(_react.Component);

exports["default"] = DatePicker, DatePicker.defaultProps = {
  enablePastDays: !1,
  displayDateFormat: "DD/MM/YYYY"
};